import { createContexts } from '../../utils';

import type { SnowplowSchemaName } from '../../schemas';
import type { EventDefinition } from '../../types';

// `chat_feedback_prompt_action` 1-0-0 (klue-snowplow #219): the session
// feedback prompt was shown, skipped, or dismissed. Answers are application
// data and emit nothing - a Yes, or a No followed by Submit, only writes a
// `thread_feedback` row.
//
// Counting note: `dismissed` writes a row too (`is_helpful` false, no comment),
// because the user did give a verdict before declining to explain it. So it
// appears in both places. Take the event stream as authoritative and exclude
// dismissed threads from the row count, or they are counted twice.
//
// `chat_session` carries the id both sides join on, and is omitted rather than
// sent empty when the surface has no session: `sessionId` is required, so an
// empty entity would bad-row.
export const chat_feedback_prompt_action: EventDefinition = {
  getData: (action) => ({ type: action }),
  addContexts: ({ eventData } = {}) => {
    const contextNames: SnowplowSchemaName[] = [];

    if (eventData?.chat_session?.sessionId) {
      contextNames.push('chat_session');
    }

    return createContexts(contextNames, { eventData });
  },
};
